import { render } from "./Godfather.vue?vue&type=template&id=e27b90e0&scoped=true"
import script from "./Godfather.vue?vue&type=script&lang=js"
export * from "./Godfather.vue?vue&type=script&lang=js"

import "./Godfather.vue?vue&type=style&index=0&id=e27b90e0&lang=scss&scoped=true"
import "./Godfather.vue?vue&type=style&index=1&id=e27b90e0&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27b90e0"]])

export default __exports__